<div class="modal fade" id="signInModal" tabindex="-1" aria-labelledby="signInModalLabel">
  <div class="modal-dialog modal-fullscreen-sm-down modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-6 ms-auto" id="signInModalLabel">{{ 'LOGIN.TITLE' | translate }}</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form class="needs-validation" novalidate (ngSubmit)="submitLoginForm()" [formGroup]="loginForm">
          <div class="mb-4 d-flex flex-row justify-content-center">
            <input type="radio" class="btn-check" id="real" formControlName="mode" value="real">
            <label class="btn btn-outline-primary me-4" for="real">{{ 'LOGIN.REAL_MODE' | translate }}</label><br>

            <input type="radio" class="btn-check" id="fun" formControlName="mode" value="fun">
            <label class="btn btn-outline-primary" for="fun">{{ 'LOGIN.FUN_MODE' | translate }}</label><br>
          </div>
          <div class="mb-4">
            <label class="form-label mb-2" for="login">{{ 'LOGIN.LOGIN_LABEL' | translate }}</label>
            <input class="form-control" type="email" id="login" placeholder="{{ 'LOGIN.LOGIN_PLACEHOLDER' | translate }}" required formControlName="login"  autocomplete="login" [ngClass]="{'is-invalid': loginSubmit && logForm['login'].errors}">
            <div class="invalid-feedback">{{ 'LOGIN.LOGIN_ALERT' | translate }}</div>
          </div>

          <div class="mb-4">
            <label class="form-label mb-2" for="password">{{ 'LOGIN.PW_LABEL' | translate }}</label>
            <div class="position-relative">
              <input class="form-control" [type]="fieldTextType ? 'text' : 'password'" id="password" required formControlName="password" autocomplete="password"
                     placeholder="{{ 'LOGIN.PW_PLACEHOLDER' | translate }}"
                     [ngClass]="{'is-invalid': loginSubmit && logForm['password'].errors}">
              <label class="password-toggle-btn" [ngClass]="{'invalid-toggle-btn': loginSubmit && logForm['password'].errors}" aria-label="Show/hide password">
                <input class="password-toggle-check" type="checkbox">
                <span class="password-toggle-indicator" [ngClass]="{'opacity-50': !fieldTextType, 'opacity-1': fieldTextType}" (click)="toggleFieldTextType()">
                  <app-svg-icon class="variable-svg-icon d-block" [pathIdentifier]="'eye'"></app-svg-icon></span>
              </label>
              <div class="invalid-feedback">{{ 'LOGIN.PW_ALERT' | translate }}</div>
            </div>
          </div>

          <button *ngIf="!isLoading, else loadingSpinner" class="btn btn-success btn-lg w-100 mb-4" type="submit" [disabled]="loginForm.invalid">
            <span >{{ 'LOGIN.TITLE' | translate }}</span>
          </button>
          <ng-template #loadingSpinner>
          <div *ngIf="isLoading" class="d-flex justify-content-center mb-4">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </ng-template>


        </form>
        <div class="text-center">
          <a class="text-decoration-none clickable-link" (click)="onResetPwModalOpened()">{{ 'LOGIN.FORGOTTEN_LINK' | translate }}</a>
          <div class="mt-2">
           <p>{{ 'LOGIN.REG_LABEL' | translate }}
             <a class="text-decoration-none ms-2 clickable-link" (click)="onRegModalOpened()">{{ 'REGISTER.BTN' | translate }}</a>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
